<template>
  <div class="iuk">
    <div class="mnl">
      <img class="iuq" src="/static/img/logonew.png" alt="Aicredit" @click="$router.push('/')" />
      <div class="vfb">Aicredit</div>
    </div>
    <div class="top_nav" v-if="isshow == '1'">
      <div :class="typeindex == 0 ? 'top_nav-active' : 'top_nav-item'" @click="$router.push('/')">Главная</div>
      <div :class="typeindex == 1 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(1)">Как получить</div>
      <div :class="typeindex == 2 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(2)">Как погасить</div>
      <div :class="typeindex == 3 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(3)">Документы</div>
      <div :class="typeindex == 4 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(4)">Вопросы и ответы</div>
      <div :class="typeindex == 5 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(5)">Обратная связь</div>
    </div>
    <div :class="isshow == '0' ? 'headAbout_textTwo' : 'head_btn'" @click="getlogin" v-if="isshow != '3'">{{btntext}}</div>
    <!-- <div class="uvf">
      <img class="nlk" src="/static/img/1.png" alt="" />
      <div class="uew">+7 778 325 9734</div>
    </div> -->
  </div>
</template>

<script>
  import {
    userStepData
  } from '@/api/info'
  export default {
    name: "HeadTab",
    props: {
      typeindex: {
        type: Number,
        default: 0
      },
      isshow:{
        type: String,
        default: '1'
      }
    },
    data() {
      return {
          flage: false,
          btntext: 'Bойти'
      };
    },
    created() {
      if(this.isshow == '0'){
        this.btntext = 'Выйти с аккаунта'
      }
    },
    methods: {
      goFn(type) {
        if (type == 1) {
          this.$router.push('/obtain')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }else if(type == 3){
          this.$router.push('/conte')
        }else if(type == 4){
          this.$router.push('/quiz')
        }else if(type == 5){
          this.$router.push('/feedback')
        }
      },
      getlogin() {
        if(this.isshow == '0'){
          localStorage.clear();
          this.$router.push('/')
          return
        }
        if(this.flage) return
        this.flage = true
        userStepData().then(res => {
          if(localStorage.getItem('token')){
            if(res.data.statusCode != 0){
              this.flage = false
              if(res.data.statusCode == 301){
                this.$router.push('/login')
              }
            }else{
              this.flage = false
              var step = res.data.payload.step
              if(step == 100){
                this.$router.push('/underreview')
              }else if(step == 12){
                this.$router.push('/underreview')
              }else{
                this.$router.push('/login')
              }
            }
          }else{
            this.flage = false
            this.$router.push('/login')
          }
        })
      }
    }
  };
</script>

<style scoped>
  .iuk{
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0.01rem 0.02rem rgba(0, 0, 0, 0.1);
    padding: 0.11rem 1.58rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mnl{
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .vfb{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.16rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .iuq{
    width: 0.32rem;
    height: 0.32rem;
    padding-right: 0.06rem;
  }
  .top_nav{
    display: flex;
    align-items: center;
    gap: 0.12rem;
  }
  .top_nav-item{
    color: #64748b;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    cursor: pointer;
  }
  .uvf{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.06rem;
    background: #FFF0ED;
    padding: 0.08rem 0.11rem;
    cursor: pointer;
  }
  .nlk{
    width: 0.13rem;
    height: 0.13rem;
    margin-right: 0.03rem;
  }
  .uew{
    color: #FF5836;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.13rem;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #FF5836;
    border-radius: 0.03rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo:hover{
    color: #FF5836;
    cursor: pointer;
  }

  .top_nav-active{
    color: #FF5836;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.08rem;
    cursor: pointer;
    border-bottom: 0.02rem solid #FF5836;
  }

  @media screen and (max-width: 1200px) {
    .iuk {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .top_nav {
      gap: 0.2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .iuk {
      padding-top: 0.16rem;
      padding-bottom: 0.16rem;
      flex-wrap: wrap;
      gap: 0.14rem;
    }
    .top_nav {
      order: 3;
      width: 100%;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadTab.vue